import GpsExtractor from './gps_extractor'
import { isHeicFile } from './file_utils'

class AssignmentLeadForm
  constructor: (selector) ->
    @form = $ selector
    @imageInput = @form.find 'input#assignment_lead_image'
    @imagePreview = @form.find '#lead-img-preview'
    @addressInput = @form.find 'input#assignment_lead_address'

    @initializeGeocomplete()
    @bindEvents()

  initializeGeocomplete: () ->
    google.maps.importLibrary('places').then () =>
      @addressInput.geocomplete country: 'DK'
      @geocomplete = @addressInput.data 'plugin_geocomplete'
      @geocoder = @geocomplete.geocoder
      @gpsExtractor = new GpsExtractor(@addressInput, @geocoder)
    .catch (error) ->
      console.error 'Error loading Google Maps:', error

  bindEvents: () ->
    @imageInput.on 'change', this.handleImageInputChange

  readAndApplyImageFile: (file) ->
    return unless 'FileReader' of window
    @imagePreview = $('#lead-img-preview')

    if isHeicFile(file)
      @imageInput.addClass 'w-75'
      @imagePreview.hide()
      @imagePreview.after("""
        <div class="heic-preview w-25">
          <i class="fa fa-image fa-3x"></i>
          <p><strong>#{file.name}</strong></p>
          <small>HEIC forhåndsvisning ikke tilgængelig.<br>Billedet vises efter upload.</small>
        </div>
      """)
      return

    reader = new FileReader()

    reader.addEventListener 'load', () =>
      @imageInput.addClass 'w-75'
      @imagePreview.removeClass 'hidden'
      @imagePreview.addClass 'w-25'
      @imagePreview.attr('src', reader.result)

    reader.readAsDataURL(file)

  handleImageInputChange: ({ target }) =>
    return unless target.files && target.files.length > 0

    # Remove any previous HEIC notice
    $('.heic-preview').remove()

    $(target.files).each (key, file) =>
      @readAndApplyImageFile file
      @gpsExtractor?.extractAndApply file

initializeAssignmentLeadForm = () ->
  new AssignmentLeadForm('form')

window.initializeAssignmentLeadForm = initializeAssignmentLeadForm
